'use client'

import { useState, type ReactNode } from 'react'
import { Provider } from 'react-redux'

import { ApisProvider } from '@/legacy-src/contexts/api-context'
import { SessionProvider } from '@/legacy-src/contexts/session-context'
import { initStore } from '@/legacy-src/services/withReduxAndAxios'
import { createApis } from '@/legacy-src/store/createApis'
import { createStore } from '@/legacy-src/store/createStore'

export interface ProvidersAuthAppRouterProps {
  children: ReactNode
}

export const ProvidersAuthAppRouter = ({ children }: ProvidersAuthAppRouterProps) => {
  const [{ apis, store }] = useState(() => {
    const ctx = createApis()
    const store = initStore({
      initialState: undefined,
      createStore,
      ctx,
    })

    ctx.apis.connect(store.getState, store.dispatch)

    return { apis: ctx.apis, store }
  })

  return (
    <ApisProvider apis={apis} setToken={apis.setToken}>
      <Provider store={store}>
        <SessionProvider>{children}</SessionProvider>
      </Provider>
    </ApisProvider>
  )
}
